// Typography.js
import styled from 'styled-components';
import { typographyStyles, fontWeights } from '../typographyStyles';
import { theme } from '../theme';
import PropTypes from 'prop-types';

const Typography = styled.span.attrs(({ as, $variant, $variantMobile, $variantTablet }) => ({
  as: as || typographyStyles[$variant]?.element || 'span',
}))`
  font-family: MonaSans, sans-serif;
  font-size: ${({ $variant }) => typographyStyles[$variant]?.fontSize || '16px'};
  line-height: ${({ $variant }) => typographyStyles[$variant]?.lineHeight || '150%'};
  font-weight: ${({ fontWeight, $variant }) =>
    fontWeight
      ? fontWeights[fontWeight.toLowerCase()] || fontWeights.regular
      : typographyStyles[$variant]?.fontWeight || fontWeights.regular};
  letter-spacing: ${({ $letterSpacing, $variant }) =>
    $letterSpacing || typographyStyles[$variant]?.letterSpacing || 'normal'};
  color: ${({ color }) => color || theme.colors.defaultMain};
  text-align: ${({ $align }) => $align || 'left'};
  text-transform: ${({ $textTransform }) => $textTransform};
  font-variant-numeric: lining-nums tabular-nums;
  font-feature-settings: 'ss01' on, 'ss05' on, 'ss06' on, 'ss07' on;
  
  /* Truncate text when $truncate prop is true */
  ${({ $truncate }) => $truncate && `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // width: -webkit-fill-available;
    width: 100%; /* Fallback */
    width: -webkit-fill-available; /* WebKit */
    width: -moz-available; /* Firefox */
    width: fill-available; 
  `}

  /* Apply tablet variant styles when screen size is between sm and md breakpoints */
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    ${({ $variantTablet }) =>
    $variantTablet &&
    `
      font-size: ${typographyStyles[$variantTablet]?.fontSize || typographyStyles['body-1-regular']?.fontSize};
      line-height: ${typographyStyles[$variantTablet]?.lineHeight || typographyStyles['body-1-regular']?.lineHeight};
      font-weight: ${typographyStyles[$variantTablet]?.fontWeight || typographyStyles['body-1-regular']?.fontWeight};
      letter-spacing: ${typographyStyles[$variantTablet]?.letterSpacing || 'normal'};
    `}
  }

  /* Apply mobile variant styles when screen size is below sm breakpoint */
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    ${({ $variantMobile }) =>
    $variantMobile &&
    `
      font-size: ${typographyStyles[$variantMobile]?.fontSize || typographyStyles['body-1-regular']?.fontSize};
      line-height: ${typographyStyles[$variantMobile]?.lineHeight || typographyStyles['body-1-regular']?.lineHeight};
      font-weight: ${typographyStyles[$variantMobile]?.fontWeight || typographyStyles['body-1-regular']?.fontWeight};
      letter-spacing: ${typographyStyles[$variantMobile]?.letterSpacing || 'normal'};
    `}
  }
`;

// Validación de props (opcional pero recomendado)
Typography.propTypes = {
  $variant: PropTypes.string,
  $variantMobile: PropTypes.string, // For mobile variant
  $variantTablet: PropTypes.string, // New prop for tablet variant
  color: PropTypes.string,
  $textTransform: PropTypes.oneOf(['none', 'uppercase', 'lowercase', 'capitalize']),
  $letterSpacing: PropTypes.string,
  $align: PropTypes.oneOf(['left', 'right', 'center', 'justify']),
  as: PropTypes.elementType,
  fontWeight: PropTypes.oneOf(['regular', 'medium', 'semibold', 'bold']),
  $truncate: PropTypes.bool,
};

export default Typography;